module.exports = __webpack_public_path__ + "img/17856_L.2016c9e6.png";